export default "__VITE_ASSET__DeSvBkU1__"